// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2lQg8","title":"ClientInsurance_title__llDMp","itemText":"ClientInsurance_itemText__1L21L"};